module.exports = " <button @click=increase _v-108078b1=\"\"> increase </button> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-108078b1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Increase.vue
 ** module id = 14
 ** module chunks = 1
 **/